import { useContext } from "react";
import UserAuthenticationContext from "~/contexts/UserAuthenticationContext";

export default function useUserAuthentication() {
  return useContext(UserAuthenticationContext);
}
